<template>
<!-- 新增/编辑行业子类、详情 -->
  <div class="contaier">
     <a-modal class="" :title="title[type-3]" :visible="subCategoryVisible"  @cancel="closeVisible"  width="50%" @ok="submit" >
        <div class="subCategoryTop">
            <span class="title" v-if="type == 3"> 新增子类 </span>
            <span class="title" v-if="type == 4"> 大类信息 </span>
        </div>
        <div class="containerTop">
                <a-form-model :model="masterCategory" ref="masterCategoryRef" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 4 }" class="model_span_form" :wrapper-col="{ span: 20}"
                            label="所属项目"  prop="categoryName">
                            <span>{{ masterCategory.categoryName}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 4 }" class="model_span_form" :wrapper-col="{ span: 20 }"
                            label="行业大类名称"  prop="industryName" :rules="{
								  required: true,
								  message: '请填写行业大类名称',
								  trigger: 'change',
								}">
                                 <span>{{masterCategory.industryName}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                 <a-row>
                    <a-col :span="24">
                        <a-form-model-item v-if="type !=4" :label-col="{ span: 4 }" class="model_span_form" :wrapper-col="{ span: 20 }"
                            label="行业子类名称"  prop="subName" :rules="{
								  required: true,
								  message: '请填写行业子类名称',
								  trigger: 'change',
								}">
                                <!-- <span v-if="type == 5">{{masterCategory.subName}}</span> -->
                                 <a-input  v-model="masterCategory.subName"></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item  v-if="type == 4" :label-col="{ span: 4 }" class="model_span_form" :wrapper-col="{ span: 20 }"
                            label="创建人"  prop="creator">
                            <span>{{masterCategory.creator}} </span>
                                 <!-- <a-input v-model="masterCategory.subName"></a-input> -->
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item  v-if="type == 4" :label-col="{ span: 4 }" class="model_span_form" :wrapper-col="{ span: 20 }"
                            label="创建时间"  prop="createTime">
                            <span>{{masterCategory.createTime}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </div>
        <div v-if="type != 5">
            <span class="title">
                现有子类
            </span>
        </div>
        <div class="containerTop" v-if="type != 5">
            <a-table :data-source="subList" bordered :loading="loading" :pagination="false" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }" >
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                    <template scope="text, record, index">
                    {{ (pagination.current - 1) * 10 + index + 1 }}
                    </template>
                </a-table-column>
                <a-table-column key="industryName" title="子类名称" ellipsis="true" data-index="industryName" />
                <a-table-column key="createTime" title="创建时间" ellipsis="true" data-index="createTime" />
                <a-table-column key="creator" title="创建人" ellipsis="true" data-index="creator" />
            </a-table>
             <Pagination 
                v-model="pagination.current"
                :total="pagination.totalCount"
                show-size-changer
                :page-size="pagination.pageSize"
                @onShowSizeChange="onShowSizeChange"
             ></Pagination>

        </div>
     </a-modal>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/index.vue'
import {industryInfo, industryInfo_post, industryInfo_put} from '@/api/Industry'
// import {industryInfo, }from '@/api/surrounding'

export default {
    props: [
        'subCategoryVisible',
        'masterCategory',
        'type',
        'subList'

    ],
    components: {
        Pagination

    },
    data() {
        return {
        //    masterCategory: {}
        subList: [],
        title:[
        '新增行业子类',
        '详情',
        '编辑行业子类',
        ],
        pagination:{ 
                //分页数据
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
        scroll_y: 150,
        }
    },
    watch:{
        subCategoryVisible() {
            // subList
            this.getList()
            console.log(this.subCategoryVisible, 'this.subCategoryVisible=====================')

        }

      

    },
    methods: {
          //分页
        onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
         this.getList()
        },
        getList() {
             industryInfo({
               pageNum: this.pagination.current,
		       pageSize: this.pagination.pageSize,
               parentId: this.masterCategory.id,
            }).then(res => {
             if(res.code == 200) {
                this.subList = res.data
                this.pagination.totalCount= res.total
                console.log( this.subList, ' this.subList===================')
             } else {
                this.$message.error(res.msg)
             }
            })

        },
        //关闭弹窗
        closeVisible() {
             this.$refs.masterCategoryRef.resetFields()
            this.subCategoryVisible = false
            this.$emit('changesubVisible',this.subCategoryVisible)

        },
        //提交弹窗数据
        submit() {
            //新增子类提交
            if( this.type == 3) {
                this.$refs.masterCategoryRef.validate( valid=>{
                 if(valid){
                    industryInfo_post({
                        parentId: this.masterCategory.id,
                        industryName: this.masterCategory.subName,
                        // projectId: this.masterCategory.projectId
                        projectId: 2,

                    }).then(res => {
                         if(res.code == 200) {
                            this.$message.success(res.msg)
                            this.$emit('getData')
                            this.masterCategory.subName = ''
                            this.subCategoryVisible = false
                             this.$emit('changesubVisible',this.subCategoryVisible)
                            console.log(this.subCategoryVisible, 'this.subCategoryVisible')
                        } else {
                             this.$message.error(res.msg)
                         }
                       
                        console.log(res, 'res======================')
                    })
                    return
                    
                 }
                })
            }
            //编辑子类提交
            if( this.type == 5) {
                this.$refs.masterCategoryRef.validate( valid=>{
                 if(valid){
                    industryInfo_put({
                        industryName: this.masterCategory.subName,
                        id: this.masterCategory.subId,
                        projectId: 2,
                    }).then(res => {
                          if(res.code == 200) {
                            
                             this.$message.success(res.msg)
                             this.$emit('getData')
                             this.subCategoryVisible = false
                             this.$emit('changesubVisible',this.subCategoryVisible)
                          } else {
                            console.log(this.masterCategory, 'masterCategory======================')
                             this.$message.error(res.msg)
                         }

                    })
                 }
                })
                return

            }

        }
    }

}
</script>

<style>
.containerTop {
    margin: 10px;
    padding: 5px;
    background-color: #fff;
    border-radius: 15px;
}
.title {
    font-size: 16px;
}
/* .containerBottom {

} */
</style>